import { useMemo } from "react";
import { AioIconButton } from "../additional/aioIconButton";
import { useTableContext } from "./TableContextProvider";
import { ADD_COLUMN, DUPLICATE_COLUMN } from "./functions/interface";

interface AitAddColumnButtonProps {
  originalColumnIndex: number;
}

/**
 * Render a small control to add or duplicate a column.
 *
 * @param props - Component props
 * @param props.originalColumnIndex - The original source index of the column before any reordering
 */
export const AitAddColumnButton = ({ originalColumnIndex }: AitAddColumnButtonProps) => {
  const { state, dispatch } = useTableContext();

  const currentCols = useMemo(
    () => state?.originalTableData.bodyData[0].rows[0].cells.length ?? 0,
    [state],
  );
  const menuItems = useMemo(() => {
    const ret = state
      ? [
          {
            label: "Add column",
            action: () =>
              dispatch({
                operation: ADD_COLUMN,
                columnIndex: originalColumnIndex,
                newColumnLength: currentCols + 1,
              }),
          },
        ]
      : [];
    if (state && originalColumnIndex >= 0) {
      ret.push({
        label: "Duplicate previous column",
        action: () =>
          dispatch({
            operation: DUPLICATE_COLUMN,
            columnIndex: originalColumnIndex,
            newColumnLength: currentCols + 1,
          }),
      });
    }
    return ret;
  }, [currentCols, dispatch, originalColumnIndex, state]);

  return !state ? null : (
    <AioIconButton
      id={`${state.id}-addcol-${originalColumnIndex}`}
      tipText="Add column"
      aria-label="Add column"
      iconName="aioxPlus"
      menuItems={menuItems}
      style={{ position: "absolute", top: "0", right: "-2px" }}
    />
  );
};

AitAddColumnButton.displayName = "AitAddColumnButton";
